import {
  CobaltFormField,
  CobaltFormFieldHelperText,
  CobaltFormFieldLabel,
} from '@cae/cobalt-react/components/form-field';
import { CobaltTextInput } from '@cae/cobalt-react/components/text-input';
import * as React from 'react';

import type { ChangeRequestFormProps } from './ChangeRequestForm.types';

import styles from './ChangeRequestForm.module.css';

const ChangeRequestForm = React.memo(
  ({
    title,
    description,
    onTitleChange,
    onDescriptionChange,
    validationErrors,
    isLoading = false,
    isSuccess = false,
  }: Readonly<ChangeRequestFormProps>): React.ReactElement => {
    const disabled = isLoading || isSuccess;

    return (
      <div
        data-testid="change-request-form"
        className={styles.changeRequestForm}
      >
        <CobaltFormField id="title" error={validationErrors.title}>
          <CobaltFormFieldLabel
            htmlFor="title"
            label="Title"
            labelAccessory={`${title.length}/30`}
          />
          <CobaltTextInput
            id="title"
            value={title}
            onChange={onTitleChange}
            disabled={disabled}
            placeholder="Type request title"
            maxLength={30}
          />
          {validationErrors.title && (
            <CobaltFormFieldHelperText
              helperId="title-helper"
              error={validationErrors.title}
            >
              {validationErrors.title}
            </CobaltFormFieldHelperText>
          )}
        </CobaltFormField>

        <CobaltFormField id="description" error={validationErrors.description}>
          <CobaltFormFieldLabel
            htmlFor="description"
            label="Description and details"
            labelAccessory={`${description.length}/1000`}
          />
          <CobaltTextInput
            id="description"
            value={description}
            onChange={onDescriptionChange}
            disabled={disabled}
            placeholder="Type request description and details"
            rows={10}
            maxLength={1000}
            multiline
            resizable
          />
          {validationErrors.description && (
            <CobaltFormFieldHelperText
              helperId="description-helper"
              error={validationErrors.description}
            >
              {validationErrors.description}
            </CobaltFormFieldHelperText>
          )}
        </CobaltFormField>
      </div>
    );
  }
);

ChangeRequestForm.displayName = 'ChangeRequestForm';

export { ChangeRequestForm };
